import React from 'react';

import styles from './styles.module.css';

function LikeIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className={styles.likeIcon}
      width="16"
      height="16"
      fill="none"
      viewBox="0 0 16 16"
    >
      <path
        fill="currentColor"
        d="M15.478 8.422c.336-.43.522-.959.522-1.508 0-.872-.502-1.697-1.31-2.157a1.384 1.384 0 00-.686-.18H9.208l.12-2.387A2.044 2.044 0 008.738.65c-.2-.206-.442-.37-.71-.481A2.188 2.188 0 007.18 0C6.14 0 5.22.68 4.944 1.652L3.226 7.69H.64a.63.63 0 00-.64.622v7.067A.63.63 0 00.64 16h12.026c.184 0 .364-.035.53-.105.952-.394 1.566-1.297 1.566-2.298 0-.245-.036-.486-.108-.719a2.451 2.451 0 00.414-2.227c.336-.43.522-.959.522-1.508a2.58 2.58 0 00-.112-.72zM1.44 14.602V9.088h1.62v5.514H1.44zM14.168 7.75l-.438.369.278.493c.092.162.14.345.138.53 0 .32-.144.625-.392.835l-.438.368.278.494c.092.162.14.344.138.53 0 .32-.144.625-.392.835l-.438.368.278.494c.092.162.14.344.138.53 0 .434-.264.827-.672 1.005H4.34V9.026l1.99-6.999a.856.856 0 01.314-.45.9.9 0 01.53-.177c.152 0 .302.043.422.13a.683.683 0 01.292.592l-.192 3.852h6.288c.356.212.576.569.576.94 0 .32-.144.623-.392.835z"
      ></path>
    </svg>
  );
}

export default LikeIcon;
